import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BusinessLoansEditFormFields } from "web_myplann/Portfolio/Forms/BusinessLoansForm/BusinessLoansEditFormFields";
import { useEditBusinessLoansForm } from "web_myplann/Portfolio/Forms/BusinessLoansForm/useEditBusinessLoansForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditBusinessLoansFormProps = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const EditBusinessLoansForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: EditBusinessLoansFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useEditBusinessLoansForm({
		portfolioId,
		portfolio,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditPortfolio.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<BusinessLoansEditFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
